import { Maybe } from "graphql/jsutils/Maybe";
import { FC, ReactElement } from "react";
import { StatusColumn } from "../common/CompletedStatusColumn";
import { CancelStatusIcon, ErrorIcon, LegacyStatusIcon, StatusIconContainer } from "../common/StatusIcon";
import { ProgressBarWaiting } from "../ui/ProgressBars";

interface IUploadStatusIcon {
  status?: string;
  rowCount?: Maybe<number>;
  large?: boolean;
}

const UploadStatusIcon: FC<IUploadStatusIcon> = ({ status, rowCount = null, large = false }) => {
  // Used in Uploads View - Derived from FlowSink.status
  let icon: ReactElement | null = null;
  if (status === "preparing") {
    icon = <ProgressBarWaiting status={status} badgeText="Waiting on processing" />;
  } else if (status === "queued") {
    icon = <ProgressBarWaiting status={status} badgeText="Queued" />;
  } else if (status === "uploading") {
    icon = <ProgressBarWaiting status={status} badgeText="Uploading" />;
  } else if (status === "loading") {
    icon = <ProgressBarWaiting status={status} badgeText="Waiting on upload repo" />;
  } else if (status === "completed") {
    icon = <StatusColumn status={status} rowCount={rowCount} />;
  } else if (status === "retrying") {
    icon = <ProgressBarWaiting status={status} badgeText="Retrying" />;
  } else if (status === "failed") {
    icon = <ErrorIcon />;
  } else if (status === "cancelled") {
    icon = <CancelStatusIcon />;
  } else {
    icon = <LegacyStatusIcon status={status} large={large} />;
  }
  return <StatusIconContainer data-cy={status}>{icon}</StatusIconContainer>;
};

export { UploadStatusIcon };
